<template>
  <v-row justify="center">
    <v-dialog
      v-model="isOpen"
      max-width="630"
      persistent
      content-class="alert-dialog"
    >
      <v-card class="card-rounded">
        <h3>
          {{ data.text }}
        </h3>
        <ui-button color="primary" @click="handleClose" class="ok-btn">
          {{ data.buttonText }}
        </ui-button>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "AlertDialog",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isOpen: true
    };
  },
  methods: {
    handleClose() {
      this.$emit("close", true);
      this.isOpen = false;
    }
  }
};
</script>
